/**
 * * end of cart upsell block part
 */
document.addEventListener("DOMContentLoaded", function () {
  const amountFreeProduct = document.querySelector("[data-treshold-product]")
    ? document.querySelector("[data-treshold-product]").getAttribute("data-treshold-product")
    : null;

  var cartTotalEl = document.querySelector(".gb-totals-total-value");
  var cart_total = cartTotalEl ? (cartTotalEl.textContent || "").trim() : "";
  if (amountFreeProduct > 0 && show_progress_bar) {
    const hasPremiumKit = document.querySelector(".premium-attachment-kit") !== null;
    if (hasPremiumKit) {
      console.log("Premium kit detected - skipping auto free gift trigger");
      return;
    }
    setTimeout(function () {
      var el = document.querySelector(".gb-totals-total-value");
      var cart_total = el ? (el.textContent || "").trim() : "";
      if (cart_total >= amountFreeProduct) {
        if (document.querySelector(".cart-item.gb-find-remove-product")) {
          console.log("Free product already in cart");
        } else {
          console.log("Adding free product");
          var trigger = document.querySelector(".gb-free-product-trigger");
          if (trigger) trigger.click();
        }
      } else {
        console.log("Removing free product - under threshold");
        var removeBtn = document.querySelector(".gb-remove-product");
        if (removeBtn) removeBtn.click();
      }
    }, 3000);

    document.body.addEventListener("click", function (e) {
      if (!e.target.closest(".gb-sumbit-free")) return;
      setTimeout(function () {
        var el = document.querySelector(".gb-totals-total-value");
        var cart_total = el ? (el.textContent || "").trim() : "";
        if (cart_total >= amountFreeProduct) {
          if (!document.querySelector(".cart-item.gb-find-remove-product")) {
            var trigger = document.querySelector(".gb-free-product-trigger");
            if (trigger) trigger.click();
          }
        } else {
          var removeBtn = document.querySelector(".gb-remove-product");
          if (removeBtn) removeBtn.click();
        }
      }, 3000);
    });
  }

  document.body.addEventListener("click", async function (e) {
    var label = e.target.closest && e.target.closest(".gb-shipping-protection-button label.switch");
    if (!label) return;
    if (e.target.tagName === "INPUT") return;
    const curElem = document.querySelector(".gb-shipping-protection-button label.switch");
    const curInputElem = document.querySelector(".gb-shipping-protection-button label.switch input");
    const spinAnim = document.querySelector(".gb-shipping-protection-button .spin-animation");
    const checkElem = document.querySelector(".gb-shipping-protection-button .complete-check");
    const wasChecked = curElem && curElem.classList.contains("checked");

    if (!wasChecked) {
      if (!curElem || !curInputElem || !spinAnim || !checkElem) return;
      if (spinAnim.style.display === "block" || curInputElem.checked) return;
      const form = document.querySelector("form.shipping-protection-form");

      const formData = new FormData(form);
      if (!formData.get("id")) {
        console.error(
          "There is no shipping protection product selected. Please select the shipping product in the global theme settings",
        );
        return;
      }

      spinAnim.style.display = "block";

      try {
        const response = await fetch(routes.cart_add_url, {
          method: "POST",
          body: formData,
          headers: {
            Accept: "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
        });

        if (response.ok) {
          spinAnim.style.display = "none";

          checkElem.style.display = "block";
        }
      } catch (err) {
        console.error("error at shipping protection form submission", err);
      }
      fetch(routes.cart_url + "?view=drawer")
        .then((response) => response.text())
        .then((html) => {
          const cartDrawer = document.querySelector("#CartDrawer");
          const parsedCartHtml = parser.parseFromString(html, "text/html");
          const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
          if (cartDrawer && newCartDrawer) {
            updateCartDrawer(cartDrawer, newCartDrawer, true, () => {
              curElem.classList.remove("unchecked");
              curElem.classList.add("checked");
              curInputElem.checked = true;
            });
          }
        })
        .catch((_err) => {
          curElem.classList.remove("unchecked");
          curElem.classList.add("checked");
          curInputElem.checked = true;
        });
    } else {
      checkElem.style.display = "none";
      const cartDrawer = document.querySelector("#CartDrawer");
      const removeButton = cartDrawer.querySelector(`cart-remove-button[data-id="${shippingProductId}"]`);
      const shippingItemIndex = removeButton?.dataset.index;

      const removeCallback = () => {
        curElem.classList.remove("checked");
        curElem.classList.add("unchecked");
        curInputElem.checked = false;
      };

      const cartItems = cartDrawer.querySelector("cart-items") || cartDrawer.querySelector("cart-drawer-items");

      if (removeButton && shippingItemIndex && cartItems?.updateQuantity) {
        const event = new CustomEvent("remove-shipping-protection", {
          detail: null,
        });
        cartItems.updateQuantity(shippingItemIndex, 0, event, "", "", removeCallback);
      } else {
        fetch(routes.cart_change_url, {
          method: "POST",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "X-Requested-With": "XMLHttpRequest",
          },
          body: JSON.stringify({ id: shippingProductId, quantity: 0 }),
        })
          .then(() => fetch(routes.cart_url + "?view=drawer"))
          .then((response) => response.text())
          .then((html) => {
            const cartDrawer = document.querySelector("#CartDrawer");
            const parsedCartHtml = parser.parseFromString(html, "text/html");
            const newCartDrawer = parsedCartHtml.querySelector("#CartDrawer");
            if (cartDrawer && newCartDrawer) {
              updateCartDrawer(cartDrawer, newCartDrawer, true, removeCallback);
            } else {
              removeCallback();
            }
          })
          .catch(() => {
            removeCallback();
          });
      }
    }
  });

  document.body.addEventListener("change", function (e) {
    var select = e.target.closest && e.target.closest(".gb-change-variant_id");
    if (!select) return;
    var opt = select.options[select.selectedIndex];
    var id_change = opt ? opt.getAttribute("data-variant-id") : null;
    if (!id_change) {
      console.error("No data-variant-id found on selected option");
      return;
    }
    var block = select.closest(".gb-get-main-freq-pro");
    var input = block ? block.querySelector(".product-variant-id") : null;
    if (input) input.value = id_change;
  });
});

document.addEventListener("change", function (e) {
  if (e.target.matches(".cart-drawer .gbfrequently-bought-with-main-whole .select__select")) {
    const parentBlock = e.target.closest(".gb-get-main-freq-pro");
    if (!parentBlock) {
      console.log("Error: Could not find parent block");
      return;
    }

    const allValues = Array.from(parentBlock.querySelectorAll(".select__select"))
      .map((sel) => sel.value)
      .join(" / ");

    const variantSelect = parentBlock.querySelector('[name="variants"]');
    if (!variantSelect) {
      console.log("Error: Could not find variant selector");
      return;
    }

    const matchedOption = Array.from(variantSelect.options).find((option) => option.text.includes(allValues));

    const idInput = parentBlock.querySelector('[name="id"]');
    if (!idInput) {
      console.log("Error: Could not find id input field");
      return;
    }

    if (matchedOption) {
      console.log("Matched variant option value:", matchedOption.value);
      idInput.value = matchedOption.value;
      console.log("Set ID input value to:", idInput.value);
    } else {
      console.log("No matching variant found for:", allValues);
    }
  }
});

// Add validation for form submissions to ensure ID parameter is present (PDP form only)
document.addEventListener("submit", function (e) {
  if (typeof Elixir_ProductFormExists !== 'function' || !Elixir_ProductFormExists()) return;
  if (typeof Elixir_GetProductForm !== 'function' || Elixir_GetProductForm() !== e.target) return;
  if (typeof Elixir_GetProductFormVariantId !== 'function') return;
  const variantId = Elixir_GetProductFormVariantId();
  if (!variantId) {
    console.log("Preventing submission - missing id parameter [expecting single product id, not list of items ids]");
    e.preventDefault();
    return false;
  }
});

document.addEventListener("DOMContentLoaded", function () {
  function handleCartQuantityChange(e) {
    var cartItem = e.target.closest(".cart-item");
    if (!cartItem) return;
    var trigger =
      e.target.closest(".quantity__button") ||
      e.target.closest(".quantity__input") ||
      (e.target.matches && e.target.matches(".quantity__input") ? e.target : null);
    if (!trigger) return;
    var quantityInputWrap = trigger.closest(".quantity-input");
    var qtyInput = quantityInputWrap ? quantityInputWrap.querySelector(".quantity__input") : null;
    var variantId = qtyInput ? qtyInput.getAttribute("data-quantity-variant-id") : null;
    var form = trigger.closest("form");
    if (!form) return;
    var idInput = form.querySelector('input[name="id"]');
    if (!idInput && variantId) {
      console.log("Adding missing ID input to cart form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = variantId;
      form.appendChild(newIdInput);
    } else if (idInput && variantId) {
      idInput.value = variantId;
    }
  }
  document.addEventListener("click", handleCartQuantityChange);
  document.addEventListener("change", handleCartQuantityChange);
  document.addEventListener("input", handleCartQuantityChange);

  var checkoutBtn = document.getElementById("CartDrawer-Checkout");
  if (checkoutBtn) {
    checkoutBtn.addEventListener("click", function (e) {
      var form = document.getElementById("CartDrawer-Form");
      if (!form) return;
      var cartItems = form.querySelectorAll(".cart-item");
      if (cartItems.length === 0) {
        console.log("No items in cart, preventing checkout");
        e.preventDefault();
        return false;
      }
      console.log("Cart checkout with", cartItems.length, "items");
    });
  }

  document.addEventListener("keydown", function (e) {
    var input =
      (e.target.matches && e.target.matches(".quantity__input")
        ? e.target
        : e.target.closest && e.target.closest(".quantity__input")) || null;
    if (!input) return;
    if (e.key === "Enter" || e.keyCode === 13) {
      e.preventDefault();
      input.blur();
    }
  });
});

document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (e) {
    var btn =
      e.target.closest(".gbfrequently-bought-with-main-whole button") ||
      e.target.closest(".gbfrequently-bought-with-main-whole .gb-sumbit-free") ||
      e.target.closest(".gb-free-product-trigger") ||
      e.target.closest(".gb-product-shipping-protection-product-tirgger") ||
      e.target.closest(".gb-product-sticky-add-to-cart-form");
    if (!btn) return;
    var parentBlock = btn.closest(".gb-get-main-freq-pro") || btn.closest("form");
    if (!parentBlock) {
      console.error("Could not find parent block for frequently bought product");
      return;
    }
    var productId = null;
    var idInput = parentBlock.querySelector('input[name="id"]');
    if (idInput && idInput.value) {
      productId = idInput.value;
    } else if (parentBlock.querySelector(".gb-change-variant_id")) {
      var select = parentBlock.querySelector(".gb-change-variant_id");
      var opt = select && select.options[select.selectedIndex];
      if (opt) {
        productId = opt.getAttribute("data-variant-id");
      }
    } else if (parentBlock.querySelector(".product-variant-id")) {
      var variantInput = parentBlock.querySelector(".product-variant-id");
      productId = variantInput ? variantInput.value : null;
    } else if (btn.getAttribute("data-variant-id")) {
      productId = btn.getAttribute("data-variant-id");
    }
    console.log("Frequently bought product add to cart - ID:", productId);
    if (btn.classList.contains("gb-free-product-trigger") && !show_progress_bar) return;
    if (!productId) {
      console.error("Missing product ID for frequently bought product");
      e.preventDefault();
      return false;
    }
    if (!idInput) {
      console.log("Adding missing ID input to frequently bought product form");
      var newIdInput = document.createElement("input");
      newIdInput.type = "hidden";
      newIdInput.name = "id";
      newIdInput.value = productId;
      parentBlock.appendChild(newIdInput);
    } else {
      idInput.value = productId;
    }
    var quantityInput = parentBlock.querySelector('input[name="quantity"]');
    if (!quantityInput) {
      console.log("Adding default quantity input to frequently bought product form");
      var newQtyInput = document.createElement("input");
      newQtyInput.type = "hidden";
      newQtyInput.name = "quantity";
      newQtyInput.value = "1";
      parentBlock.appendChild(newQtyInput);
    } else if (!quantityInput.value || parseFloat(quantityInput.value, 10) < 1) {
      quantityInput.value = "1";
    }
  });
});

/**
 * Synchronize Kaching bundle pricing with the PDP add-to-cart button.
 * This is the ONLY script that writes the Add to cart price text
 * (the separator logic was removed from bk-pdp.js).
 */
(() => {
  /* Separator between "Add to cart" and the price.
     Use ' • ' for the bullet design, or ' - ' for a dash. */
  const SEPARATOR = ' • ';

  const SELECTORS = {
    app: 'kaching-bundle',
    selectedBundle: '.kaching-bundles__bar:has(input:checked)',
    price: '.kaching-bundles__bar-price',
    comparePrice: '.kaching-bundles__bar-full-price',
    button: 'product-form .shop-add-to-cart-button',
    buttonText: '.button-text'
  };

  const normalizeText = (value = '') => value.replace(/\s+/g, ' ').trim();

  const cleanPriceText = (element) => {
    if (!element) return '';
    return normalizeText(element.textContent).replace(/^\(/, '').replace(/\)$/, '');
  };

  const initializeKachingPriceSync = () => {
    const app = document.querySelector(SELECTORS.app);
    const button = document.querySelector(SELECTORS.button);
    if (!app || !button) return false;

    if (button.dataset.kachingPriceSync === 'true') return true;
    button.dataset.kachingPriceSync = 'true';

    /* Remembers the last valid compare price per bundle, so Kaching's
       temporary "$39.99 / $39.99" state doesn't replace the real one. */
    const validComparePrices = new WeakMap();
    let animationFrameId = null;

    const renderButtonPrice = () => {
      const selectedBundle = app.querySelector(SELECTORS.selectedBundle);
      const buttonTextElement = button.querySelector(SELECTORS.buttonText);
      if (!selectedBundle || !buttonTextElement) return;

      const price = cleanPriceText(selectedBundle.querySelector(SELECTORS.price));
      let comparePrice = cleanPriceText(selectedBundle.querySelector(SELECTORS.comparePrice));
      if (!price) return;

      if (comparePrice && comparePrice !== price) {
        validComparePrices.set(selectedBundle, comparePrice);
      } else {
        comparePrice = validComparePrices.get(selectedBundle) || '';
      }

      const buttonLabel =
        button.dataset.persistentText || button.dataset.originalText || 'Add to cart';

      const expectedText = normalizeText(
        `${buttonLabel}${SEPARATOR}${price}${comparePrice ? ` ${comparePrice}` : ''}`
      );

      /* Already correct → do nothing (this is what prevents endless loops) */
      if (normalizeText(buttonTextElement.textContent) === expectedText) return;

      const fragment = document.createDocumentFragment();
      fragment.append(document.createTextNode(`${buttonLabel}${SEPARATOR}${price}`));

      if (comparePrice) {
        const comparePriceElement = document.createElement('span');
        comparePriceElement.className = 'compare-price';
        comparePriceElement.textContent = comparePrice;
        fragment.append(document.createTextNode(' '), comparePriceElement);
      }

      buttonTextElement.replaceChildren(fragment);
    };

    const scheduleUpdate = () => {
      if (animationFrameId) cancelAnimationFrame(animationFrameId);
      animationFrameId = requestAnimationFrame(() => {
        animationFrameId = null;
        renderButtonPrice();
      });
    };

    /* Watch Kaching for bundle selection / price changes */
    new MutationObserver(scheduleUpdate).observe(app, {
      childList: true,
      subtree: true,
      characterData: true
    });

    /* Watch the button in case Kaching or the theme rewrites it */
    new MutationObserver(scheduleUpdate).observe(button, {
      childList: true,
      subtree: true,
      characterData: true
    });

    app.addEventListener('change', scheduleUpdate);
    scheduleUpdate();
    return true;
  };

  const bootKachingPriceSync = () => {
    if (initializeKachingPriceSync()) return;

    /* Kaching loads after the page, so wait for it */
    const pageObserver = new MutationObserver(() => {
      if (initializeKachingPriceSync()) pageObserver.disconnect();
    });
    pageObserver.observe(document.documentElement, { childList: true, subtree: true });

    /* Give up after 15s if Kaching never loads */
    window.setTimeout(() => pageObserver.disconnect(), 15000);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootKachingPriceSync, { once: true });
  } else {
    bootKachingPriceSync();
  }
})();


/* Top price block ko selected bundle ke sath update karo
   (now only watches the Kaching block, not the whole page) */
(function () {
  function num(t) { return parseFloat(String(t || '').replace(/[^0-9.]/g, '')) || 0; }
  function setText(el, t) { if (el && el.textContent.trim() !== t) el.textContent = t; }
  function show(el, on) { if (el) { var d = on ? '' : 'none'; if (el.style.display !== d) el.style.display = d; } }

  function update() {
    var bar = document.querySelector('.kaching-bundles__bar--selected');
    var box = document.getElementById('block-price');
    if (!bar || !box) return;
    var pEl = bar.querySelector('.kaching-bundles__bar-price');
    var cEl = bar.querySelector('.kaching-bundles__bar-full-price');
    if (!pEl) return;

    var pT = pEl.textContent.trim(), cT = cEl ? cEl.textContent.trim() : '';
    var p = num(pT), c = num(cT);
    var C = box.querySelector('.shop-compare-price');
    var S = box.querySelector('.shop-save-price');

    setText(box.querySelector('.shop-product-price-block'), pT);
    if (c > p) {
      setText(C, cT);
      setText(S, 'SAVE ' + Math.round((c - p) / c * 100) + '%');
    }
    show(C, c > p);
    show(S, c > p);
  }

  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () { queued = false; update(); });
  }

  var tries = 0;
  function init() {
    if (!document.getElementById('block-price')) return; // not a PDP with the price block
    var root = document.querySelector('kaching-bundle');
    if (!root) {
      if (++tries < 50) setTimeout(init, 300); // wait up to ~15s for Kaching
      return;
    }
    root.addEventListener('change', schedule, true);
    root.addEventListener('click', function () { setTimeout(update, 100); }, true);
    new MutationObserver(schedule).observe(root, {
      subtree: true, attributes: true, attributeFilter: ['class']
    });
    update();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();


/* Remove the Kaching space placeholder (CSS in bk-pdp.css) if Kaching fails to load */
setTimeout(function () {
  if (!document.querySelector('kaching-bundle')) {
    document.documentElement.classList.add('kaching-timeout');
  }
}, 5000);